import React, { Component } from "react";

import PermissionComboSelect from "./PermissionComboSelect";
import TagPermission from "./TagPermission";
//import { GenericAlert } from 'com-gyf-webcore-userinterfacecomponents';

class PanelPermisos extends Component {
    constructor(props) {
        super(props);

        this.state = {
            activePermission: true,
            mostrarAlert: true
        }
    }

    onToggleButtonClick = (event) => {
        this.setState({ activePermission: true });
    }

    onPermissionClick = (event) => {
        this.setState({ activePermission: true });
    }

    onRestrictionClick = (event) => {
        this.setState({ activePermission: false });
    }

    selectProducto(idPermiso, idProducto) {
        this.props.selectProductoPermiso(idPermiso, idProducto);
    }

    selectCategoria(idPermiso, idCategoria) {
        this.props.selectCategoriaPermiso(idPermiso, idCategoria);
    }

    selectPrograma(idPermiso, idPrograma) {
        this.props.selectProgramaPermiso(idPermiso, idPrograma);
    }

    render() {
        const { props } = this;

        let panelId = "permission-restriction-panel" + props.permiso.id;

        let functions = props.permiso.listaFunciones.map((f, index) => {
            return (
                <li key={"combo-permission-function" + index}>
                    <a data-toggle="collapse"
                        data-target={"#" + panelId}
                        data-functionid={f.id}
                        onClick={() => props.addFuncion(props.permiso.id, f.id, this.state.activePermission)}>
                        {f.descripcion}
                    </a>
                </li>
            );
        });

        let permissionsGiven = props.permiso.funciones.map((f, index) => {
            return (
                <TagPermission
                    descripcion={f.descripcion}
                    permisoId={props.permiso.id}
                    id={f.id}
                    flag={f.flag}
                    removeFuncion={props.removeFuncion} />
            );
        });

        let parafunciones = (onToggle) => {

            return (
                <div>
                    <span>Para...</span>
                    <br />

                    <button className="btn btn-cta btn-sm-2 collapsed"
                        data-toggle="collapse" data-target={"#" + panelId}
                        onClick={onToggle}>+</button>
                </div>
            );


        }

        return (
            <div className="panel panel-default no-margin-bottom top-separator-xxs">
                <div className="panel-body">
                    <div className="row">
                        <div className="col-xs-11">
                            <PermissionComboSelect
                                permiso={props.permiso}

                                selectProductoPermiso={(permiso, producto) => this.selectProducto(permiso, producto)}
                                selectCategoriaPermiso={(permiso, categoria) => this.selectCategoria(permiso, categoria)}
                                selectProgramaPermiso={(permiso, programa) => this.selectPrograma(permiso, programa)} />
                        </div>
                        <div className="col-xs-1 text-right">
                            <div onClick={() => props.deletePermiso(props.permiso.id)}>
                                <span className="ti-close clickable"></span>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-12">
                            <ul className="list-inline">{permissionsGiven}</ul>
                            {(props.permiso.allowPermisos) ? parafunciones(this.onToggleButtonClick)
                                : <div className="row">
                                    <div className="col-md-12">
                                        <br />
                                        <div className="alert alert-warning">
                                            <ul>
                                                <li>
                                                    Recuerde que debe seleccionar todos los campos antes de asignar las funciones.
                                            </li>
                                                <li>
                                                    Si ya tiene una función seleccionada y cambia de Producto/Categoria/Programa la función sera borrada. Debe agregar nuevos bloques de permiso.
                                            </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>}

                        </div>
                        <div className="col-md-12">
                            <div className="collapse" id={panelId}>
                                <ul className="btn-group dropdown-menu">
                                    <li>
                                        <button type="button" className={"btn btn-default" + ((this.state.activePermission == true) ? "active" : "")}
                                            onClick={this.onPermissionClick}>Permiso</button>
                                        <button type="button" className={"btn btn-default" + ((this.state.activePermission == false) ? "active" : "")}
                                            onClick={this.onRestrictionClick}>Restricción</button>
                                    </li>
                                    {functions}
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default PanelPermisos;